import { useLocation, useParams, useNavigate } from "react-router-dom";

const axios = require("axios").default;

function DeleteSet() {
  const navigate = useNavigate();
  const { state } = useLocation();
  let params = useParams();

  function Delete() {
    const token = localStorage.getItem("token");

    axios
      .post(
        `https://application-flashcards.herokuapp.com/api/sets/delete/${params.id}`,
        {
          token,
        }
      )
      .then(function (response) {
        console.log(response);
      })
      .catch(function (error) {
        console.log(error);
      });

    window.location.href = `https://aquamarine-gingersnap-e8df1d.netlify.app/dashboard`;
  }

  return (
    <>
      <div className="bg-zinc-800 text-slate-200 py-2 px-32 md:px-12">
        <p className="text-xl font-semibold my-2">{state.nameCap}</p>
      </div>
      <div className="rounded-lg border-solid border border-slate-200 my-2 w-4/12 shadow-md p-2 mx-auto mt-24 xsm:mx-auto xsm:my-5 xsm:w-10/12 md:w-6/12">
        <h2 className="font-semibold text-2xl mt-2">Delete Set</h2>
        <p className="py-2">
          Are you sure you want to delete set{" "}
          <span className="font-bold">{state.nameCap}</span>?
        </p>
        <div className="flex justify-end">
          <button
            className="w-2/12 text-white bg-sky-400 border-solid border border-neutral-50 rounded p-1 hover:bg-sky-500 xsm:w-3/12 md:w-4/12 xl:w-4/12"
            onClick={() => {
              navigate(-1);
            }}
          >
            Back
          </button>
          <button
            className="w-2/12 text-white bg-red-400 border-solid border border-neutral-50 rounded p-1 hover:bg-red-500 xsm:w-3/12 md:w-4/12 xl:w-4/12"
            onClick={Delete}
          >
            Delete
          </button>
        </div>
      </div>
    </>
  );
}

export default DeleteSet;
